export default __webpack_public_path__ + "static/media/manbigsmile.d625cf33.png";